// extracted by mini-css-extract-plugin
export default {"video_loading":"style_video_loading__E0dd+","inner":"style_inner__drY39","rotate":"style_rotate__c4y2A"};